import { render, staticRenderFns } from "./PlayerBadge.vue?vue&type=template&id=2f6d90e0&scoped=true&"
import script from "./PlayerBadge.vue?vue&type=script&lang=js&"
export * from "./PlayerBadge.vue?vue&type=script&lang=js&"
import style0 from "./PlayerBadge.vue?vue&type=style&index=0&id=2f6d90e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d90e0",
  null
  
)

export default component.exports